import React from 'react';

import { Redirect, Route } from 'react-router-dom';
import { isAdminUser, isLoggedIn, isStaffUser } from '../utils/auth';
import Cookies from 'js-cookie';

const Redirection = props => {
  /*
   *  Use the Redirection component specially if you want to redirect from the website to the ors-frontend
   *  and the PrivateRoute doesn't cover it.
   */
  const { component: Component, url, ...rest } = props;
  const reviewId = Cookies.get('reviewId');
  const reviewType = Cookies.get('reviewType');

  props.location.pathname = url + props.location.pathname.replace('redirect', '');

  return (
    <Route
      {...rest}
      render={() => (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location, origin: 'review', reviewId: reviewId, reviewType: reviewType },
          }}
        />
      )}
    />
  );
};

export default Redirection;
